/**
 * @typedef {import('./lib/index.js').Options} Options
 */

export {cont, name, start} from './lib/index.js'
